/* eslint-disable import/no-unresolved */
import { useEffect } from 'react';
import Highcharts from 'highcharts';

const PieChart = (
    {
        totalTestExecuted, totalTestCompleted, totalTestFailed, totalTestInError,
    },
) => {
    const totalPercent = 100;
    const result = totalTestExecuted;
    const passedTests = (totalTestCompleted && totalTestCompleted !== 0) ? (totalTestCompleted / result) * totalPercent : 0;
    const failedTests = (totalTestFailed && totalTestFailed !== 0) ? (totalTestFailed / result) * totalPercent : 0;
    const testInError = (totalTestInError && totalTestInError !== 0) ? (totalTestInError / result) * totalPercent : 0;

    let pieChart;
    useEffect(() => {
        pieChart = new Highcharts.Chart({
            chart: {
                renderTo: 'pie-four',
                type: 'pie',
            },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false,
                    },
                },
            },
            series: [
                {
                    type: 'pie',
                    name: 'Value',
                    innerSize: '70%',
                    size: 75,
                    animation: false,
                    data: [
                        {
                            name: 'Failed Tests % ',
                            y: failedTests,
                            color: '#D93954',
                        },
                        {
                            name: 'Passed Tests %',
                            y: passedTests,
                            color: '#2C8646',
                        },
                        {
                            name: 'Test In Error %',
                            y: testInError,
                            color: '#EB8C00',
                        },
                    ],
                },
            ],
        });
        return () => {
            pieChart.destroy();
        };
    }, [pieChart, totalTestExecuted, totalTestCompleted, totalTestFailed]);

    return (
        <div id="pie-four" style={{ height: 80 }} />
    );
};

export default PieChart;
